export default __webpack_public_path__ + "static/media/pinMapa.aec07a7c.svg";